import { requestKarangoApi } from "../../core/api/karangoTransport";

// Invitation au statut « Organisateur certifie » (ADR-019). Ne jamais logger les URL :
// elles contiennent le jeton d'invitation.

export async function getOrganizerInvitation(token) {
  const payload = await requestKarangoApi(`/v1/organizer-invitations/${encodeURIComponent(token)}`, {
    optionalAuth: true,
  });
  return payload?.invitation ?? null;
}

export async function respondToOrganizerInvitation(token, accept) {
  return requestKarangoApi(
    `/v1/organizer-invitations/${encodeURIComponent(token)}/${accept ? "accept" : "decline"}`,
    { method: "POST", requiresAuth: true }
  );
}

export async function listOrganizerInvitations() {
  const payload = await requestKarangoApi("/v1/admin/organizer-invitations", { requiresAuth: true });
  return Array.isArray(payload?.invitations) ? payload.invitations : [];
}

export async function createOrganizerInvitation(kind = "ORGANIZER") {
  const payload = await requestKarangoApi("/v1/admin/organizer-invitations", {
    method: "POST",
    requiresAuth: true,
    body: { kind },
  });
  return payload?.invitation ?? null;
}

export async function revokeOrganizerInvitation(invitationId) {
  return requestKarangoApi(`/v1/admin/organizer-invitations/${encodeURIComponent(invitationId)}/revoke`, {
    method: "POST",
    requiresAuth: true,
  });
}
